export default __webpack_public_path__ + "static/media/1.f936a3a7.jpeg";